export enum ENotification {
  ERROR = 'error',
  WARNING = 'warning',
  SUCCESS = 'success',
}

export type TNotification =
  | ENotification.ERROR
  | ENotification.WARNING
  | ENotification.SUCCESS;

export interface INotification {
  type: TNotification;
  msg1: string;
  value1?: any;
  msg2?: string;
  value2?: any;
  status?: number;
  id?: string;
  dispatch?: any;
  func?: any;
  cb?: any;
}

export interface IError {
  data: { exceptionName: TErrorName };
  status: number;
}

export enum EErrorName {
  AmountPollNotFoundException = 'AmountPollNotFoundException',
  ContactNotFoundException = 'ContactNotFoundException',
  GroupNotFoundException = 'GroupNotFoundException',
  MemberGroupNotFoundException = 'MemberGroupNotFoundException',
  UserNotFoundException = 'UserNotFoundException',
  WishNotFoundException = 'WishNotFoundException',
  WishPhotoNotFoundException = 'WishPhotoNotFoundException',
  WishPollNotFoundException = 'WishPollNotFoundException',
  WishListNotFoundException = 'WishListNotFoundException',
  CurrentUserIsNotAdminException = 'CurrentUserIsNotAdminException',
  CurrentUserIsNotOwnerException = 'CurrentUserIsNotOwnerException',
  InvalidImageTypeException = 'InvalidImageTypeException',
  NotCurrentUserWishListException = 'NotCurrentUserWishListException',
  UnspecifiedAmountException = 'UnspecifiedAmountException',
  UnspecifiedWishException = 'UnspecifiedWishException',
  UserAlreadyContactException = 'UserAlreadyContactException',
  UserAlreadyRegisteredException = 'UserAlreadyRegisteredException',
  UserIsNotGroupAdminException = 'UserIsNotGroupAdminException',
  UserIsNotMemberGroupException = 'UserIsNotMemberGroupException',
  UserIsNotMemberOfGroupException = 'UserIsNotMemberOfGroupException',
  UserIsNotWishListOwnerException = 'UserIsNotWishListOwnerException',
  WishReservationException = 'WishReservationException',
  WishListIsDefaultException = 'WishListIsDefaultException',
  WishListNameNotValidException = 'WishListNameNotValidException',
  ForbiddenUserException = 'ForbiddenUserException',
  EmailNotVerifyException = 'EmailNotVerifyException',
  InvalidPaymentCodeException = 'InvalidPaymentCodeException',
  InvalidSignatureException = 'InvalidSignatureException',
  InvalidSignatureVersionException = 'InvalidSignatureVersionException',
  ModifyAmountNotAllowedException = 'ModifyAmountNotAllowedException',
  PendingPaymentNotFoundException = 'PendingPaymentNotFoundException',
  RequiredParamNotFoundException = 'RequiredParamNotFoundException',
  UserCantDeleteTheContactException = 'UserCantDeleteTheContactException',
  UserHasAlreadyLikedThisWishException = 'UserHasAlreadyLikedThisWishException',
  UserHasPaymentPaidException = 'UserHasPaymentPaidException',
  InactiveUserException = 'InactiveUserException',
  ResendEmailException = 'ResendEmailException',
  RequiredAmountException = 'RequiredAmountException',
}

export type TErrorName =
  | EErrorName.AmountPollNotFoundException
  | EErrorName.ContactNotFoundException
  | EErrorName.GroupNotFoundException
  | EErrorName.MemberGroupNotFoundException
  | EErrorName.UserNotFoundException
  | EErrorName.WishNotFoundException
  | EErrorName.WishPhotoNotFoundException
  | EErrorName.WishPollNotFoundException
  | EErrorName.WishListNotFoundException
  | EErrorName.CurrentUserIsNotAdminException
  | EErrorName.CurrentUserIsNotOwnerException
  | EErrorName.InvalidImageTypeException
  | EErrorName.NotCurrentUserWishListException
  | EErrorName.UnspecifiedAmountException
  | EErrorName.UnspecifiedWishException
  | EErrorName.UserAlreadyContactException
  | EErrorName.UserAlreadyRegisteredException
  | EErrorName.UserIsNotGroupAdminException
  | EErrorName.UserIsNotMemberGroupException
  | EErrorName.UserIsNotMemberOfGroupException
  | EErrorName.UserIsNotWishListOwnerException
  | EErrorName.WishReservationException
  | EErrorName.WishListIsDefaultException
  | EErrorName.WishListNameNotValidException
  | EErrorName.ForbiddenUserException
  | EErrorName.EmailNotVerifyException
  | EErrorName.InvalidPaymentCodeException
  | EErrorName.InvalidSignatureException
  | EErrorName.InvalidSignatureVersionException
  | EErrorName.ModifyAmountNotAllowedException
  | EErrorName.PendingPaymentNotFoundException
  | EErrorName.RequiredParamNotFoundException
  | EErrorName.UserCantDeleteTheContactException
  | EErrorName.UserHasAlreadyLikedThisWishException
  | EErrorName.UserHasPaymentPaidException
  | EErrorName.InactiveUserException
  | EErrorName.ResendEmailException
  | EErrorName.RequiredAmountException;

export const noBackErrors = [
  EErrorName.WishReservationException,
  EErrorName.InactiveUserException,
  EErrorName.ResendEmailException,
  EErrorName.RequiredAmountException,
];
